module.exports = {
  EN: {
    code: 'en',
    title: 'English'
  }, // English
  JA: {
    code: 'ja',
    title: '日本語'
  } // Japanese
};


// WEBPACK FOOTER //
// ./src/constants/languages.js